import { NgModule } from '@angular/core';
import { signalProvider } from './provider';

@NgModule({
	providers: [signalProvider],
})
export class DataSignalrModule {}
